export const OPEN_MAIN_SIDE_BAR = 'OPEN_MAIN_SIDE_BAR'
export const CLOSE_MAIN_SIDE_BAR = 'CLOSE_MAIN_SIDE_BAR'
export const UPDATE_FILTER_VALUE = 'UPDATE_FILTER_VALUE'

export const SHOW_UNBOOK_MODAL = 'SHOW_UNBOOK_MODAL'
export const HIDE_UNBOOK_MODAL = 'HIDE_UNBOOK_MODAL'
export const UNBOOK_MODAL_CHANGE = 'UNBOOK_MODAL_CHANGE'

export const SHOW_REDUX_MODAL = 'SHOW_REDUX_MODAL'
export const HIDE_REDUX_MODAL = 'HIDE_REDUX_MODAL'
export const RESET_REDUX_MODAL = 'RESET_REDUX_MODAL'
export const TOGGLE_CONFIRM_AVAILABILITY_REDUX_MODAL =
  'TOGGLE_CONFIRM_AVAILABILITY_REDUX_MODAL'



// WEBPACK FOOTER //
// ./src/Reducers/UI/const.js